import { Opengraph } from '../../components/Opengraph/Opengraph';
import { Button } from '../../components/buttons/Button/Button';
import Footer from 'components/Footer';
// import Header from 'components/Header';
import { colorsVariants, whiteIcons } from './assets';
import favicon from '../../images/icons/favicon.svg';
import variant1 from '../../images/icons/headerIcons/variant1.svg';
import variant2 from '../../images/icons/headerIcons/variant2.svg';
import variant3 from '../../images/icons/headerIcons/variant3.svg';
import variant4 from '../../images/icons/headerIcons/variant4.svg';
import variant5 from '../../images/icons/headerIcons/variant5.svg';
import variant6 from '../../images/icons/headerIcons/variant6.svg';
import variant7 from '../../images/icons/headerIcons/variant7.svg';
import variant8 from '../../images/icons/headerIcons/variant8.svg';
import betino from '../../images/betino.png';
import wuxal from '../../images/wuxal.png';
import fertiplant from '../../images/fertiplant.png';
import uniferX from '../../images/uniferX.png';
import './ui-kit.css';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import Logo from 'components/Logo';

export const UIKit = () => {
    return (
        <div className="container">
            <div className="ui-kit">
                <h2>Favicon & Opengraph</h2>
                <Logo />
                <img src={favicon} alt="favicon" width={16} />
                <img src={favicon} alt="big favicon" width={512} />
                <Opengraph />
                <h2>Colors</h2>
                <div className="color-box-wrapper">
                    {colorsVariants.map(el => (
                        <div key={el.name}>
                            <p className="body1">{el.name}</p>
                            <div style={{ background: el.hex }} className="color-box"></div>
                        </div>
                    ))}
                </div>
                <h2>Icons</h2>
                <div className="ui-kit-icons">
                    <img src={variant1} alt="variant1" />
                    <img src={variant2} alt="variant2" />
                    <img src={variant3} alt="variant3" />
                    <img src={variant4} alt="variant4" />
                    <img src={variant5} alt="variant5" />
                    <img src={variant6} alt="variant6" />
                    <img src={variant7} alt="variant7" />
                    <img src={variant8} alt="variant8" />
                </div>
                <div className="ui-kit-icons">
                    <img src={betino} alt="betino" />
                    <img src={wuxal} alt="wuxal" />
                    <img src={fertiplant} alt="fertiplant" />
                    <img src={uniferX} alt="uniferX" />
                </div>
                <div className="ui-kit-icons"></div>
                <div className="ui-kit-icons">
                    {whiteIcons.map(el => (
                        <img src={el.image} alt={el.alt} key={el.alt} />
                    ))}
                </div>
                <h2>Typography</h2>
                <div className="typography">
                    <div>
                        <h1>H1</h1>
                        <h2>H2</h2>
                        <h3>H3</h3>
                        <h4>H4</h4>
                        <p className="button-text">BUTTON</p>
                    </div>
                    <div>
                        <p className="description-medium">Description Medium</p>
                        <p className="description-demibold">Description DemiBold</p>
                        <p className="body1">Body 1</p>
                        <p className="body2">Body 2</p>
                        <p className="body3">Body 3</p>
                        <p className="body4">Body 4</p>
                    </div>
                </div>
                <h2>Buttons</h2>
                <div className="buttons-wrapper">
                    <Button type="button-arrow">BUTTON</Button>
                    <Button type="button-arrow disabled">BUTTON</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button>BUTTON</Button>
                    <Button type="disabled">BUTTON</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="button-eye">BUTTON</Button>
                    <Button type="button-eye disabled">BUTTON</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="download-button">BUTTON</Button>
                    <Button type="download-button disabled">BUTTON</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="find-desktop">BUTTON</Button>
                    <Button type="find-desktop disabled">BUTTON</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="find-mobile">BUTTON</Button>
                    <Button type="find-mobile disabled">BUTTON</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="learn-more">LEARN MORE</Button>
                    <Button type="learn-more disabled">LEARN MORE</Button>
                </div>
                <Button type="show-more">SHOW MORE</Button>
                <Button type="show-more-white">SHOW MORE</Button>
                <div className="buttons-wrapper">
                    <Button type="attach-file">ATTACH A FILE</Button>
                    <Button type="attach-file disabled">ATTACH A FILE</Button>
                </div>
                {/* <div className="buttons-wrapper"> */}
                <Button type="news">NEWS</Button>
                <Button type="news active">NEWS</Button>
                {/* </div> */}
                <div className="buttons-wrapper">
                    <Button type="view" />
                    <Button type="view disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="download" />
                    <Button type="download disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="read-more">READ MORE</Button>
                    <Button type="read-more opened">COLLAPSE</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="instagram-black" />
                    <Button type="instagram-black disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="send" />
                    <Button type="send disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="next" />
                    <Button type="next disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="next backwards" />
                    <Button type="next backwards disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="learn-more-arrow white-text">LEARN MORE</Button>
                    <Button type="learn-more-arrow white-text disabled">LEARN MORE</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="learn-more-arrow" />
                    <Button type="learn-more-arrow disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="clear">CLEAR</Button>
                    <Button type="clear disabled">CLEAR</Button>
                </div>
                <div className="buttons-wrapper">
                    <Button type="instagram" />
                    <Button type="instagram disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="facebook" />
                    <Button type="facebook disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="youtube" />
                    <Button type="youtube disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="close small" />
                    <Button type="close small disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="close" />
                    <Button type="close disabled" />
                </div>
                <div className="buttons-wrapper">
                    <Button type="close big" />
                    <Button type="close big disabled" />
                </div>
                {/* <div className="buttons-wrapper">
                    <Checkbox />
                    <Checkbox isChecked={true} />
                </div> */}
                <h2>Links</h2>
                {/* <div className="buttons-wrapper">
                    <Link type="link-dropdown">COMPANY</Link>
                    <Link type="link-dropdown disabled">COMPANY</Link>
                </div>
                <div className="buttons-wrapper">
                    <Link type="change-country">CHANGE COUNTRY</Link>
                    <Link type="change-country disabled">CHANGE COUNTRY</Link>
                </div> */}
                {/* <CheckForm>
                    <span>I agree to the</span> <Link href="https://www.google.com">Terms of Use</Link>
                    <span> and</span> <Link>Privacy Policy</Link>
                </CheckForm> */}
                {/* <Link type="special-offer">
                    Announces a <span>special offer!</span>
                </Link> */}
                <h2>Input</h2>
                {/* <div className="buttons-wrapper">
                    <Input type="email" placeholder="Your email" />
                </div> */}
                <h2>Dropdown</h2>
                {/* <Dropdown label="SELECT A SENDER CATEGORY*" options={dropdownArray} /> */}
                <h2>Header</h2>
                <div className="header-wrapper">{/* <Header /> */}</div>
                <h2>Menu items</h2>

                <h2>Search items</h2>
                {/* <SearchItem image={wuxalProduct} title="Wuxal P Max" group="PRODUCTS • WUXAL" /> */}
                <h2>Choosing a country (pop-up)</h2>
                {/* <div className="change-country-wrapper">
                    <CountrySelectorMenu onOpenMenu={''} />
                </div> */}
                <h2>CTA form</h2>
                <DefaultForm />
                <h2>Form on the career page</h2>
                <CareerForm />
                <h2>Footer</h2>
                <Footer />
            </div>
        </div>
    );
};
